import React, { Component, Fragment } from "react";
import InsureeMasterPanel from "./InsureeMasterPanel";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Contributions, PublishedComponent, formatMessage, withModulesManager } from "@openimis/fe-core";

const POLICY_POLICY_PANELS_CONTRIBUTION_KEY = "policy.Policy.panels";

class HeadInsureeMasterPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edited: props.edited || {},
    };
  }

  updateAttribute = (key, value) => {
    // Prevent redundant state updates
    if (this.state.edited[key] !== value) {
      const updatedEdited = {
        ...this.state.edited,
        [key]: value,
      };

      this.setState({ edited: updatedEdited });

      if (this.props.onEditedChanged) {
        this.props.onEditedChanged(updatedEdited);
      }
    }
  };

  render() {
    const { intl, edited, edited_id, readOnly, fetchingPolicyValues, user } = this.props;
    const { edited: stateEdited } = this.state;

    return (
      <Fragment>
        <InsureeMasterPanel
          {...this.props}
          edited={edited?.headInsuree || null}
          onEditedChanged={(head) => {
            const updatedEdited = { ...edited, headInsuree: head };
            this.props.onEditedChanged(updatedEdited);
          }}
        />
      </Fragment>
    );
  }
}

export default withModulesManager(connect((state) => ({ user: state.core.user }))(injectIntl(HeadInsureeMasterPanel)));
